var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "flat": "",
      "tile": "",
      "outlined": ""
    }
  }, [_c('v-card-title', [_c('span', [_vm._v(" 근로자 이력서 ")]), _c('v-spacer'), _c('application-view', _vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "my-n10",
          attrs: {
            "small": "",
            "text": "",
            "outlined": ""
          }
        }, 'v-btn', attrs, false), on), [_c('span', [_vm._v(" 이력서 보기 ")])])];
      }
    }])
  }, 'application-view', {
    value: _vm.value.application
  }, false))], 1), _c('vertical-form-table', _vm._b({}, 'vertical-form-table', {
    mode: 'view',
    value: _vm.value,
    items: _vm.items,
    style: 'margin-bottom: -1px'
  }, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }